import styled from 'styled-components';
import Button from '@prisjakt/ui-button';
import { layout, remCalc, media } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import CloseIcon from 'mdi-react/CloseCircleOutlineIcon';
import { applyFilterAreaHeight } from '../../../category/components/filter/components/apply-filter-button/styles';

type SectionProps = {};

export const Filter = styled.ul`
  list-style: none;
`;

export const FilterTitle = styled.h2.attrs({ className: 'show-for-sr' })``;

export const AppliedFilterCount = styled.span`
  align-items: center;
  border-radius: 50%;
  background: ${({ theme }) => theme.bg.primary};
  color: ${({ theme }) => theme.text.primary};
  display: inline-flex;
  height: 16px;
  justify-content: center;
  margin-left: ${layout.spacing.xSmall};
  width: 16px;
`;

export const AppliedFilters = styled.div`
  margin-top: ${layout.spacing.xSmall};

  ${media.largeUp`
    margin-top: 0;
  `}
`;

export const AppliedFilter = styled(Clickable)`
  align-items: center;
  background: ${({ theme }) => theme.buttons.primary.bg};
  border-radius: ${layout.borderRadius};
  color: white;
  cursor: pointer;
  display: inline-flex;
  font-size: ${layout.fontSizes.small.mobile.rem};
  margin: 0 ${layout.spacing.xxSmall} ${layout.spacing.xxSmall} 0;
  max-width: 250px;
  padding: ${layout.spacing.xSmall};
  text-align: left;

  ${media.largeUp`
    font-size: ${layout.fontSizes.small.desktop.rem};
  `}
`;

export const AppliedFilterText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AppliedFilterIcon = styled(CloseIcon).attrs({ size: 14 })`
  flex: 0 0 auto;
  margin-left: ${layout.spacing.xxSmall};
`;

export const Group = styled.li`
  list-style: none;
`;

export const GroupTitle = styled.h3`
  font-size: ${layout.fontSizes.base.desktop.rem};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const SectionList = styled.ul`
  list-style: none;
`;

export const Section = styled.li<SectionProps>`
  padding: 0 ${layout.spacing.xxSmall} ${layout.spacing.xSmall};
  &:not(:first-child) {
    padding-top: ${layout.spacing.xSmall};
    &::before {
      border-top: 1px solid ${props => props.theme.lines.primary};
      content: '';
      display: block;
      margin: 0 ${remCalc(-layout.spacing.values.small)};
    }
  }
`;

export const MobileFilterDialog = styled.div`
  min-width: 0;
  flex: 1 1 0;
  background: ${p => p.theme.bg.primary};
  position: fixed;
  padding: 0 ${layout.spacing.xSmall};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 102;
  overflow-x: hidden;
  overflow-y: scroll; /* has to be scroll, not auto */
  -webkit-overflow-scrolling: touch;
  /* Makes sure no content is hidden behind the "apply filter" area */
  ::after {
    content: '';
    display: block;
    height: ${applyFilterAreaHeight}px;
  }
`;

export const MobileFilterCloseButton = styled.button.attrs({ type: 'button' })`
  background: ${p => p.theme.bg.primary};
  border-radius: 50%;
  box-shadow: 0 2px 10px -4px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  display: block;
  margin-bottom: 0.5rem;
  padding: 10px 12px;
  position: fixed;
  right: 5px;
  top: 5px;
  z-index: 100;
`;

export const MobileFilterToggle = styled(Button)`
  display: none;
  width: 100%;
  ${media.mediumDown`
    display: block;
  `}
`;
